/*
 * @Author: Src
 * @Date: 2025-02-07 15:47:48
 * @LastEditTime: 2026-04-08 15:02:06
 * @LastEditors: Src
 * @FilePath: /work-station/src/services/image.service.ts
 * @Description: 头部注释配置模板
 */
import { injectable, inject } from 'inversify';
import HttpClient from './http.service';
import { BASE_CAR_URL } from '@/common/constant';


@injectable()
export default class ImageService {
  @inject(HttpClient)
  protected http!: HttpClient;

  /**
   * 图片ocr识别
   * 0101身份证   0301营业执照
   * new_edit 1 标记无效字段 数据库
   */
  async getAutoOffShelfTime(params: any) {
    try {
      const res = await this.http.post('tool/ocr/recognize', params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }

    /**
   * 图片ocr识别
   * 0101身份证   0301营业执照
   */
  async getCarAutoOffShelfTime(params: any) {
    try {
      const res = await this.http.post(`${BASE_CAR_URL}/tool/ocr/recognize`, params) as any;
      return res;
    } catch (error) {
      return null;
    }
  }
}
